import React__default from 'react';
import { Skeleton } from '../../../skeleton/skeleton.js';

var sizes = {
  xs: {
    height: '12px',
    width: '120px'
  },
  s: {
    height: '12px',
    width: '120px'
  },
  m: {
    height: '16px',
    width: '120px'
  },
  l: {
    height: '16px',
    width: '120px'
  }
};
var SubtitleLoader = function SubtitleLoader(_ref) {
  var size = _ref.size;
  var _sizes$size = sizes[size],
      height = _sizes$size.height,
      width = _sizes$size.width;
  return /*#__PURE__*/React__default.createElement(Skeleton, {
    rounding: 8,
    height: height,
    width: width
  });
};

export { SubtitleLoader };
